module.exports = __webpack_public_path__ + "img/6f5c3.334b11d1.svg";